/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Calendar_GenerateInputs */



/**
* | output |
* | --- |
* | "Generate link" |
*
* @param {Tournaments_Calendar_GenerateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_calendar_generate = /** @type {((inputs?: Tournaments_Calendar_GenerateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Calendar_GenerateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Générer le lien")
	if (locale === "es") return /** @type {LocalizedString} */ ("Generar enlace")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Gerar link")
	if (locale === "it") return /** @type {LocalizedString} */ ("Genera link")
	return /** @type {LocalizedString} */ ("Generate link")
});